import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
  siteKey: '6Lc7-VQoAAAAAL8NLti9vkKGhWGplWQ0BdJzUNqx'
});
